import React from 'react';

const ServicesOneABout = () => {
   return (
      <>
         <section className="about-area pt-120 pb-90">
            <div className="container">
               <div className="row ">
                  <div className="col-xl-6 col-lg-6 col-md-12">
                     <div className="section-title section-title-m-0 pos-rel mb-50 text-end">
                        <div className="section-icon">
                           <img className="section-back-icon back-icon-right" src="img/section/section-back-icon.png" alt="" />
                        </div>
                        <div className="section-text section-text-small pos-rel">
                           <h5>health care facility</h5>
                           <h1>Would you rather stay at home than go into a health care facility?</h1>
                        </div>
                     </div>
                  </div>
                  <div className="col-xl-6 col-lg-6 col-md-12">
                     <div className="facalty-text mb-50">
                        <p>
                           The Department of orthopaedics is at the forefront in offering the latest in orthopaedic treatment and surgical advancements at par. Our specialists are focused on all kind of musculoskeletal conditions including joint pain, spine pain, trauma, sports, birth & congenital defects and other injuries. We have dedicated and well equipped surgery complexes with laminar flow and various modern equipments. All the surgeries including the most delicate micro surgeries are performed with great precision and expertise. We perform bone & joint replacement surgery, Shoulder surgery, Sport surgery in large numbers with excellent outcomes.
                           <br />
                           We focus on to get our patient back on their feet and provide them with highest possible quality of life.
                        </p>
                     </div>
                  </div>
               </div>
               {/* <div className="row">
                  <HomeSIngleService icon="1" title="Body Surgery" border_className="service-box-border" />
                  <HomeSIngleService icon="2" title="Dental Care" border_className="service-box-border" />
                  <HomeSIngleService icon="3" title="service-content" border_className="service-box-border" />
                  <HomeSIngleService icon="4" title="Blood Cancer" border_className="service-box-border" />
                  <HomeSIngleService icon="5" title="Neurology Sargery" border_className="service-box-border" />
                  <HomeSIngleService icon="6" title="Allergic Issue" border_className="service-box-border" />
               </div> */}
            </div>
         </section>
      </>
   );
};

export default ServicesOneABout;